import { render, staticRenderFns } from "./DeleteWastes.vue?vue&type=template&id=7b5467d6&scoped=true&"
import script from "./DeleteWastes.vue?vue&type=script&lang=js&"
export * from "./DeleteWastes.vue?vue&type=script&lang=js&"
import style0 from "./DeleteWastes.vue?vue&type=style&index=0&id=7b5467d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5467d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5467d6')) {
      api.createRecord('7b5467d6', component.options)
    } else {
      api.reload('7b5467d6', component.options)
    }
    module.hot.accept("./DeleteWastes.vue?vue&type=template&id=7b5467d6&scoped=true&", function () {
      api.rerender('7b5467d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/waste/modal/DeleteWastes.vue"
export default component.exports